import React, { useEffect, useState } from "react";
import { Menu, Layout, Badge } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { t } from "i18next";
import styles from "../style";
import menuItems from "./menuItems";
import { getCountPending } from "services/dashboard";

const { Sider } = Layout;

const rootSubmenuKeys = ["/performance", "/reports", "/sales-force"];
export default function SideBar() {
  const [menu, setMenu] = useState([]);
  const [openKeys, setOpenKeys] = useState([]);
  const [selectKeys, setSelectKeys] = useState([""]);
  let location = useLocation();
  const navigate = useNavigate();
  const pathName = location.pathname;
  const onSelect = ({ keyPath, selectedKeys }) => {
    if (
      keyPath[1] === "/performance" ||
      keyPath[1] === "/reports" ||
      keyPath[1] === "/sales-force"
    ) {
      setSelectKeys(selectedKeys);
    } else {
      setSelectKeys(keyPath);
    }
  };

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);

    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  useEffect(() => {
    const key = pathName.split("/");
    if (
      key[1] === "performance" ||
      key[1] === "reports" ||
      key[1] === "sales-force"
    ) {
      setOpenKeys([`/${key[1]}`]);
      setSelectKeys([`/${key[1]}/${key[2]}`]);
    } else {
      setOpenKeys([]);
      setSelectKeys([`/${key[1]}`]);
    }

    getCountPending()
      .then(summaries => {
        if (summaries) {
          summaries = summaries.map(summary => ({ ...summary, count: parseInt(summary.count) }));

          // const leave = summaries.find(summary => summary.type === "leave");
          // if (leave) {
          //   const menuItem = menuItems.find(menuItem => menuItem.key === "/leaves");
          //   menuItem.label = <Link to="/leaves">{t("text_leaves_request")}<Badge count={leave?.count} style={{ marginLeft: 15 }} /></Link>
          // }

          const overtime = summaries.find(summary => summary.type === "overtime");
          if (overtime) {
            const menuItem = menuItems.find(menuItem => menuItem.key === "/overtime-request");
            menuItem.label = <Link to="/overtime-request">{t("text_overtime_request")}<Badge count={overtime?.count} style={{ marginLeft: 15 }} /></Link>;
          }

          const timesheet = summaries.find(summary => summary.type === "timesheet");
          if (timesheet) {
            const menuItem = menuItems.find(menuItem => menuItem.key === "/timesheets");
            menuItem.label = <Link to="/timesheets">{t("text_timesheet")}<Badge count={timesheet?.count} style={{ marginLeft: 15 }} /></Link>;
          }

          setMenu(menuItems);
        }
      }).catch((error) => {
        if (error.response.status === 403) {
          localStorage.removeItem("ACCESS_TOKEN");
          navigate("/signin");
        }
      })

  }, [pathName,navigate]);

  return (
    <Sider width={220} className="main-sidebar-menu" id="non-printable" style={{ backgroundColor: "#1d8747" }}>
      <div style={styles.sidebarUserinfo}>
        <img alt="Logo" src="/logo.png" style={{ height: 52 }} />
      </div>
      <Menu
        onSelect={onSelect}
        onOpenChange={onOpenChange}
        theme="light"
        selectedKeys={selectKeys}
        openKeys={openKeys}
        mode="inline"
        items={menu}
      />
    </Sider>
  );
}
